<template>
  <v-card class="my-4" v-if="students">
    <v-toolbar color="primary" flat dark>
      <v-toolbar-title
        >Students who haven't accepted the invitation</v-toolbar-title
      >
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="students"
      no-data-text="Looks like all your students have accepted their invitation"
    >
      <template v-slot:body="{ items }">
        <tr v-for="(item, index) in items" :key="index">
          <!-- no longer used for privacy reasons <td>{{ item.name }}</td> -->
          <td class="text-center">{{ item.code }}</td>
          <td class="text-center">{{ item.class }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'StudentInviteNotAccepted',
  async mounted() {
    this.students = await this.$axios.get(
      'api/teachers/reports?type=studentPendingInvitation&date_start=2019-01-01&date_end=2019-01-01'
    )
  },
  data() {
    return {
      students: null,
      headers: [
        // {
        // no longer used for privacy reasons
        //   text: 'Student Name',
        //   align: 'left',
        //   sortable: true,
        //   value: 'name'
        // },
        {
          text: 'Invitation Code',
          align: 'center',
          sortable: true,
          value: 'code'
        },
        {
          text: 'Class',
          align: 'center',
          sortable: false,
          value: 'class'
        }
      ]
    }
  }
}
</script>

<style lang="scss"></style>
